<template>
	<div class="mt-2 xl:mt-4 flex w-full justify-around lg:px-28 xl:px-32 2xl:px-32 3xl:px-32">
		<div v-for="method in share" :key="method">
			<button @click="method.action" class="flex mx-4">
				<img :src="method.image" alt="Features Icons" class="w-5 h-5 mr-1 m-auto" />
				<span class="m-auto text-start flex w-full justify-start text-ihh-slate-gray text-xs">
					{{ method.title }}
				</span>
			</button>
			<div
				v-if="method.title === 'Share' && showSocials"
				class="absolute flex justify-evenly items-center ml-3 my-1 w-40 space-x-1 py-3 shadow-xl rounded-lg bg-ihh-white border"
			>
				<div v-for="s in socials">
					<a :href="s.url" target="_blank">
						<img :src="s.img" :alt="s.name" class="h-4" />
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProductSharingOptions',
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			productUrl: '',
			showSocials: false,
			share: [
				{
					title: 'Email',
					image: 'https://cfl-mango.s3.amazonaws.com/uploads/downloads/ob-envelope.svg',
					action: this.shareToEmail,
				},
				{
					title: 'Print',
					image: '/images/ob-print-0129.svg',
					action: this.shareToPrinter,
				},
				{
					title: 'Share',
					image: '/images/ob-share-0129.svg',
					action: this.toggleSocials,
				},
			],
		}
	},
	mounted() {
		if (this.product?.customUrl?.url) {
			this.productUrl = this.product.customUrl.url
		}
	},
	methods: {
		shareToEmail() {
			const subject = `${this.product.name} - In His Hands Birth Supply`
			const body = `Check out this product: https://www.inhishands.com${this.product.customUrl.url}`
			const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
			window.location.href = mailtoLink
		},
		shareToPrinter() {
			// Print the page
			window.print()
		},
		shareToSocials() {},
		toggleSocials() {
			this.showSocials = !this.showSocials
		},
	},
	computed: {
		socials() {
			if (!this.productUrl) {
				return [] // Return an empty array until productUrl is set
			}

			return [
				{
					name: 'FB',
					img: '/images/ihh-facebook0129.svg',
					url: `https://www.facebook.com/sharer/sharer.php?u=https://www.inhishands.com${this.productUrl}`,
				},
				{
					name: 'X',
					img: '/images/x.svg',
					url: `https://twitter.com/intent/tweet?url=https://www.inhishands.com${this.productUrl}`,
				},
				{
					name: 'Pinterest',
					img: '/images/ihh-pinterest0129.svg',
					url: `https://pinterest.com/pin/create/button/?url=https://www.inhishands.com${this.productUrl}`,
				},
			]
		},
	},
}
</script>

<style scoped></style>
